import { render, staticRenderFns } from "./EventsEdit.vue?vue&type=template&id=2b88bf1e"
import script from "./EventsEdit.vue?vue&type=script&lang=js"
export * from "./EventsEdit.vue?vue&type=script&lang=js"
import style0 from "./EventsEdit.vue?vue&type=style&index=0&id=2b88bf1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports